import React, { useEffect, useState } from 'react';

import { Card, Button, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import { useTranslate } from 'react-polyglot';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Resources.scss';
import PageTable from '../../Shared/PageTable/PageTable';
import FilterSelector from '../../Shared/FilterSelector/FilterSelector';
import Field from '../../Shared/Wizard/Field/Field';
import MaintenanceResourceModal from '../../Shared/Maintenance/MaintenanceResourceModal';
import EditMaintenance from '../../Shared/Maintenance/EditMaintenance/EditMaintenance';
import StringToIcon from '../../Shared/StringToIcon/StringToIcon';

import * as buffer from 'buffer';
(window as any).Buffer = buffer;

function Resources() {
    const auth = useAuth();
    const t = useTranslate();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [resourceTypes, setResourceTypes] = useState<Array<Object>>([]);
    const [resources, setResources] = useState<Array<Object>>([]);

    const [deals, setDeals] = useState<Array<Object>>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const notifySuccess = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "success-toast"
    });

    const notifyWarning = (text) => toast(text, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: "warning-toast"
    });

    const [editResource, setEditResource] = useState({
        name: "",
        resourceType: "",
        location: "",
        description: "",
        productId: "",
        props: [""],
        capacity: "",
        maintenance: [""]
    } as any);

    const [deleteResource, setDeleteResource] = useState({
        name: "",
        resourceType: "",
        location: "",
        description: "",
        productId: "",
        props: [""],
        capacity: "",
        maintenance: [""]
    })

    const setEditResourceName = value => { setEditResource(editResource => ({ ...editResource, name: value })); }
    const setEditResourceType = value => { setEditResource(editResource => ({ ...editResource, resourceType: value })); }
    const setEditResourceSubtype = value => { setEditResource(editResource => ({ ...editResource, resourceSubtype: value })); }
    const setEditResourceLocation = value => { setEditResource(editResource => ({ ...editResource, location: value })); }
    const setEditResourceDescription = value => { setEditResource(editResource => ({ ...editResource, description: value })); }
    const setEditResourceProductId = value => { setEditResource(editResource => ({ ...editResource, productId: value })); }
    const setEditResourceProps = value => { setEditResource(editResource => ({ ...editResource, props: value })); }
    const setEditResourceCapacity = value => { setEditResource(editResource => ({ ...editResource, capacity: value })); }
    //const setEditResourceMaintenance = value => { setEditResource(editResource => ({ ...editResource, maintenance: value })); }

    const [newResourceName, setNewResourceName] = useState("");
    const [newResourceType, setNewResourceType] = useState("");
    const [newResourceSubType, setNewResourceSubType] = useState("");
    const [newResourceLocation, setNewResourceLocation] = useState("");
    const [newResourceDescription, setNewResourceDescription] = useState("");
    const [newResourceProductId, setNewResourceProductId] = useState("");
    const [newResourceProps, setNewResourceProps] = useState<Array<Object>>([]);
    const [newResourceCapacity, setNewResourceCapacity] = useState(0);
    const [newResourceMaintenance, setNewResourceMaintenance] = useState([]);

    const [show, setShow] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showMaintenanceModal, setShowMaintenanceModal] = useState(false);
    const [showEditMaintenance, setShowEditMaintenance] = useState(false);
    const [showToggle, setShowToggle] = useState(false);

    const [updateTable, setUpdateTable] = useState(0);
    const [multiResources, setMultiResources] = useState<any>([]);
    const [currentResourceId, setCurrentResourceId] = useState("");
    const [editMaintenanceKey, setEditMaintenanceKey] = useState("");
    const [resourceFilter, setResourceFilter] = useState([]);


    function handleShow() {
        setShow(true);
    }
    function handleClose() {
        setShow(false);
        cleanNewForm();
    };

    const handleShowEditModal = (dataLine) => {
        setEditResource(dataLine);
        setShowEditModal(true);
    }
    const handleCloseEditModal = () => setShowEditModal(false);

    const handleShowDeleteModal = (dataLine, evt) => {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();

        if (isDealExist(dataLine["_id"]).length != 0) {
            notifyWarning(t("booking.general.toast_resourceisattached")); return undefined;
        }

        setDeleteResource(dataLine);
        setShowDeleteModal(true);
    }
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    function cleanNewForm() {
        setNewResourceName("");
        setNewResourceType("");
        setNewResourceSubType("");
        setNewResourceLocation("");
        setNewResourceDescription("");
        setNewResourceProductId("");
        setNewResourceProps([]);
        setNewResourceCapacity(0);
        setNewResourceMaintenance([]);
    };

    function handleCreateResource() {

        if (newResourceName == "") { notifyWarning(t("resources.toast_resources_empty_name")); return undefined; }
        if (newResourceType == undefined || newResourceType == "") { notifyWarning(t("resources.toast_resources_empty_resourcetype")); return undefined; }
        if (newResourceSubType == undefined || newResourceSubType == "") { notifyWarning(t("resources.toast_resources_empty_resourceSubtype")); return undefined; }
        if (newResourceProductId == "" ){ notifyWarning(t("resources.toast_resources_empty_resourceProductId")); return undefined; }

        axios.post(
            "/api/resources",
            {
                name: newResourceName,
                resourceType: newResourceType,
                resourceSubtype: newResourceSubType,
                location: newResourceLocation,
                description: newResourceDescription,
                productId: newResourceProductId,
                props: newResourceProps,
                capacity: newResourceCapacity,
                maintenance: newResourceMaintenance
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            cleanNewForm();
            fetchData();
            notifySuccess(t("resources.toast_resources_created"));
            handleClose();
            setUpdateTable(updateTable + 1);
        });
    };

    // Inserts default props based on resourceType chosen when making a new resource
    const handleNewResourceType = (val) => {
        setNewResourceType(val.value);
        let tempResourceType = (resourceTypes.find(i => i["_id"] == val.value)) || { defaultProps: [] };
        setNewResourceProps(tempResourceType["defaultProps"])
    }

    const addProp = () => {
        setNewResourceProps([...newResourceProps != undefined ? newResourceProps : [], { name: "", value: "" }]);
    }
    const handleNewPropName = (val, key) => {
        let temp = newResourceProps != undefined ? newResourceProps : [];
        temp[key]["name"] = val;
        setNewResourceProps(JSON.parse(JSON.stringify(temp)));
    }
    const handleNewPropValue = (val, key) => {
        let temp = newResourceProps != undefined ? newResourceProps : [];
        temp[key]["value"] = val;
        setNewResourceProps(JSON.parse(JSON.stringify(temp)));
    }
    const deleteProp = (key) => {
        let temp = newResourceProps;
        temp.splice(key, 1);
        setNewResourceProps(JSON.parse(JSON.stringify(temp)));
    }

    const addEditProp = () => {
        setEditResourceProps([...editResource["props"] != undefined ? editResource["props"] : [], { name: "", value: "" }]);
    }
    const handleEditPropName = (val, key) => {
        let temp = editResource["props"] != undefined ? editResource["props"] : [];
        temp[key]["name"] = val;
        setEditResourceProps(JSON.parse(JSON.stringify(temp)));
    }
    const handleEditPropValue = (val, key) => {
        let temp = editResource["props"] != undefined ? editResource["props"] : [];
        temp[key]["value"] = val;
        setEditResourceProps(JSON.parse(JSON.stringify(temp)));
    }
    const deleteEditProp = (key) => {
        let temp = editResource["props"];
        temp.splice(key, 1);
        setEditResourceProps(JSON.parse(JSON.stringify(temp)));
    }

    function handleEditResource() {
        if (editResource["name"] == "") { notifyWarning(t("resources.toast_resource_empty_name")); return undefined; };
        if (editResource["resourceType"] == undefined || editResource["resourceType"] == "") { notifyWarning(t("resources.toast_resources_empty_resourcetype")); return undefined; }
        if (editResource["resourceSubtype"] == undefined || editResource["resourceSubtype"] == "") { notifyWarning(t("resources.toast_resources_empty_resourceSubtype")); return undefined; }
        if (editResource["productId"] == undefined || editResource["productId"] == "") { notifyWarning(t("resources.toast_resources_empty_resourceProductId")); return undefined; }

        axios.put(
            "/api/resources/" + editResource["_id"],
            {
                name: editResource["name"],
                resourceType: editResource["resourceType"],
                resourceSubtype: editResource["resourceSubtype"],
                location: editResource["location"],
                description: editResource["description"],
                productId: editResource["productId"],
                props: editResource["props"],
                capacity: editResource["capacity"],
                //maintenance: editResource["maintenance"]
            },
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            handleCloseEditModal();
            setUpdateTable(updateTable + 1);
            notifySuccess(t("resources.toast_updated"))
            fetchData();
        });
    };

    function handleDeleteResource() {
        axios.delete(
            "/api/resources/" + deleteResource["_id"],
            {},
            {
                headers: { 'x-access-token': auth.user["token"] }
            }
        ).then(res => {
            fetchData();
            notifySuccess(t("resources.toast_resources_deleted"));
            handleCloseDeleteModal();
            setUpdateTable(updateTable + 1);
        });
    };

    const handleEditResourceType = value => {
        setEditResourceType(value.value);
        setEditResourceSubtype("");
    }

    async function fetchData() {
        setLoading(true);
        axios.all([
            axios.single({
                method: "get",
                url: "api/resourcetypes",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "api/deals",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
            axios.single({
                method: "get",
                url: "/api/resources/",
                responseType: "json",
                headers: { 'x-access-token': auth.user["token"] }
            }),
        ]).then(axios.spread((...res) => {
            setResourceTypes(res[0].data);
            setDeals(res[1].data);
            setResources(res[2].data);
            setLoading(false);
        })).catch(err => console.log(err));
        setUpdateTable(updateTable + 1);
    };

    function handleShowMaintenanceModal(dataLine, evt) {
        setShowToggle(true);
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setCurrentResourceId(dataLine["_id"]);
        setShowMaintenanceModal(true);
    }

    function handleCloseMaintenanceModal() {
        setUpdateTable(updateTable + 1);
        setShowMaintenanceModal(false);
        setCurrentResourceId("");
        setMultiResources([]);
    }

    function handleEditMaintenance(evt, resourceID, key) {
        evt.stopPropagation();
        evt.nativeEvent.stopImmediatePropagation();
        setCurrentResourceId(resourceID);
        setEditMaintenanceKey(key);
        setShowEditMaintenance(true);
    }

    const handleSetMaintenance = (multiResources) => {
        setShowToggle(false);
        setMultiResources(multiResources);
        setShowMaintenanceModal(true);
    }

    function isDealExist(resourceId) {
        let foundDeal: Array<any> = [];
        deals.forEach(deal => {
            let tmpResult = deal["priceList"].find(p => p.resource == resourceId);
            if (tmpResult != undefined) foundDeal.push(tmpResult);
        })
        return foundDeal;
    }

    function fetchExcelResourcesReport() {
        axios.single({
            method: "post",
            url: "/api/reports/fullresourcesexcel/",
            responseType: "arraybuffer",
            headers: {'x-access-token': auth.user["token"]}
        }).then(res => {
            let file = buffer.Buffer.from(res.data);
            const blob = new Blob( [ file ], { type: 'text/plain' } );
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = "Resourcesrapport_" + new Date().toISOString().split(".")[0] + ".xlsx";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        });
    }

    useEffect(() => {
        if (auth.user["userdata"] == undefined) { window.location.href = "/login"; }
        fetchData();
    }, [currentResourceId, multiResources]);

    return (
        <>
            <div className="maincontent">
                <div className="resources-container">
                    <Card>
                        <Card.Body>
                            <h4 className="header-title">{t("resources.title")}</h4>
                            <div className="no-print">
                                {auth.user["userdata"]["role"][0] === "Admin" &&
                                    <Button className="newresourceBtn" disabled={!(resourceTypes.length > 0)} onClick={handleShow}>{t("resources.new")}</Button>
                                }
                                { resourceTypes.length == 0 && loading == false &&
                                    <p>{t("resources.no_resourcetypes_found")}</p>
                                }
                                {auth.user["userdata"]["role"][0] === "Admin" &&
                                    <Button onClick={fetchExcelResourcesReport} style={{float: "right"}}>{t("export.excel")}</Button>
                                }
                                <br />
                                <hr />
                                <p>{t("resources.filters")}</p>
                                <FilterSelector
                                    filtersUrl="/api/filters/bytype/"
                                    filterType="resources"
                                    fields={[
                                        { label: t("resources.resourceType"), value: "resourceTypeReadable", type: "string" },
                                        { label: t("resources.location"), value: "location", type: "string" },
                                        { label: t("resources.maintenance_field"), value: "openMaintenanceFilter", type: "string" }
                                    ]}
                                    onChange={(filter) => setResourceFilter(filter.filters)}
                                    onAddClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                    onEditClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                    onDeleteClick={ auth.user["userdata"]["role"][0] === "Admin" ? () => {} : undefined}
                                    addFilterText={t("resources.addfilter")}
                                />
                            </div>
                            
                            <PageTable
                                dataUrl="/api/resources/getAllPaged/"
                                checkAllUrl="/api/resources/getAllPaged/checkAll"
                                allDataUrl="/api/resources"
                                options={{
                                    showFields: [
                                        { label: t("resources.name"), field: "name" },
                                        { label: t("resources.resourceType"), field: "resourceTypeCombined" },
                                        { label: t("resources.capacity"), field: "capacity" },
                                        { label: t("resources.location"), field: "location" },
                                        {
                                            label: t("resources.maintenance_field"), field: "openMaintenanceFilter",
                                            override: (data) => data.openMaintenance.map(

                                                (maintenance, i) =>  (
                                                    
                                                    <OverlayTrigger key={i}
                                                        placement={"top"}
                                                        overlay={
                                                            <Tooltip id={`tooltip-${"top"}`}>
                                                                {maintenance.name}: {maintenance.description}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <div className="maintenanceIcon" style={{display: "flex"}}>
                                                        <StringToIcon icon={maintenance["type"]} onClick={(evt) => handleEditMaintenance(evt, data["_id"], maintenance.key)} />
                                                          <p>{maintenance.type?.name ?? ""}</p>
                                                        </div>
                                                    </OverlayTrigger>
                                                )
                                            )
                                        },
                                        { label: t("resources.current_guests"), field: "currentPeople" }
                                    ]
                                }}
                                selectedFunctions={[
                                    { label: t("resources.list.multifunctions.create_maintenance"), func: (selectedItems) => { handleSetMaintenance(selectedItems); } },
                                ]}
                                dataAfter={(dataLine) => {
                                    return (
                                        <>
                                            <Button
                                                className="maintenanceButton no-print" onClick={(evt) => handleShowMaintenanceModal(dataLine, evt)}
                                                style={{
                                                    marginBottom: "10px"
                                                }}
                                            >{t("resources.show_maintenance")}</Button>
                                            { auth.user["userdata"]["role"][0] === "Admin" ?
                                                <Button
                                                    className="no-print" onClick={(evt) => handleShowDeleteModal(dataLine, evt)}
                                                    style={{
                                                        marginBottom: "10px",
                                                        marginLeft: "10px"
                                                    }}
                                                >{t("resources.delete")}</Button>
                                            : null }
                                        </>
                                    )
                                }}
                                onLineClick={handleShowEditModal}
                                hidePagination={false}
                                hidePagesize={false}
                                hideFilter={false}
                                updateTable={updateTable}
                                hover={true}
                                permaFilters={resourceFilter}
                            />
                        </Card.Body>
                    </Card>
                </div>
            </div>

            {/* Creating modal */}
            <Modal show={show} onHide={handleClose} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resources.new_title")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("resources.new_name")}
                        value={newResourceName}
                        onChange={value => setNewResourceName(value)}
                        placeholder={t("resources.new_name")}
                    ></Field>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="select"
                                title={t("resources.new_resourceType")}
                                value={{ value: newResourceType }}
                                onChange={value => handleNewResourceType(value)}
                                options={{
                                    choosetext: t("resources.choosetext_type"),
                                    choices: resourceTypes != undefined ? resourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                }}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="select"
                                disabled={newResourceType == ""}
                                title={t("resources.new_resourceSubtype")}
                                value={{ value: newResourceSubType }}
                                onChange={value => setNewResourceSubType(value.value)}
                                options={{
                                    choosetext: t("resources.choosetext_subtype"),
                                    choices: resourceTypes != undefined ? (resourceTypes.find(i => i["_id"] == newResourceType) || { resourceSubtype: ["null"] })["resourceSubtype"].map(function (item, key) {
                                        return { label: item, value: item }
                                    }) : null
                                }}
                            ></Field>
                        </div>
                    </div>
                    <Field
                        type="input"
                        title={t("resources.new_location")}
                        value={newResourceLocation}
                        onChange={val => setNewResourceLocation(val)}
                        placeholder={t("resources.new_location")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_capacity")}
                        value={newResourceCapacity}
                        onChange={val => setNewResourceCapacity(val)}
                        placeholder={t("resources.new_capacity")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_description")}
                        value={newResourceDescription}
                        onChange={val => setNewResourceDescription(val)}
                        placeholder={t("resources.new_description")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_productId")}
                        value={newResourceProductId}
                        onChange={val => setNewResourceProductId(val)}
                        placeholder={t("resources.new_productId")}
                    ></Field>
                    <hr />
                    <h3 style={{ fontSize: "18px" }}>{t("resources.prop_title")}</h3>
                    {
                        newResourceProps != undefined ? newResourceProps.map((item, key) =>
                            <div className="propContainer row" key={key} >
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resources.prop_name")}
                                        value={item["name"]}
                                        onChange={(val) => { handleNewPropName(val, key) }} ></Field>
                                </div>
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resources.prop_value")}
                                        value={item["value"]}
                                        onChange={(val) => { handleNewPropValue(val, key) }} ></Field>
                                </div>
                                <div className="col-sm-2">
                                    <Button onClick={() => deleteProp(key)}>{t("resources.prop_delete")}</Button>
                                </div>
                            </div>
                        )
                            : null
                    }
                    <Button onClick={addProp}>{t("resources.prop_add")}</Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleClose}>
                        {t("resources.cancel_without_save")}
                    </Button>
                    <Button onClick={handleCreateResource}>
                        {t("resources.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Editing modal */}
            <Modal show={showEditModal} onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resources.resources_edit")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Field
                        type="input"
                        title={t("resources.new_name")}
                        value={editResource["name"]}
                        onChange={val => setEditResourceName(val)}
                    ></Field>
                    <div className="row">
                        <div className="col col-sm-6">
                            <Field
                                type="select"
                                title={t("resources.new_resourceType")}
                                value={{ value: editResource["resourceType"] }}
                                onChange={value => handleEditResourceType(value)}
                                options={{
                                    choosetext: t("resources.choosetext_type"),
                                    choices: resourceTypes != undefined ? resourceTypes.map(i => { return { label: i["name"], value: i["_id"] } }) : null
                                }}
                            ></Field>
                        </div>
                        <div className="col col-sm-6">
                            <Field
                                type="select"
                                title={t("resources.new_resourceSubtype")}
                                disabled={editResource["resourceType"] == ""}
                                value={{ value: editResource["resourceSubtype"] != null ? editResource["resourceSubtype"] : "" }}
                                onChange={value => setEditResourceSubtype(value.value)}
                                options={{
                                    choosetext: t("resources.choosetext_subtype"),
                                    choices: resourceTypes != undefined ? (resourceTypes.find(i => i["_id"] == editResource["resourceType"]) || { resourceSubtype: ["null"] })["resourceSubtype"].map(function (item, key) {
                                        return { label: item, value: item }
                                    }) : { label: "", value: "" }
                                }}
                            ></Field>
                        </div>
                    </div>
                    <Field
                        type="input"
                        title={t("resources.new_location")}
                        value={editResource["location"]}
                        onChange={val => setEditResourceLocation(val)}
                        placeholder={t("resources.new_location")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_capacity")}
                        value={editResource["capacity"]}
                        onChange={val => setEditResourceCapacity(val)}
                        placeholder={t("resources.new_capacity")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_description")}
                        value={editResource["description"]}
                        onChange={val => setEditResourceDescription(val)}
                        placeholder={t("resources.new_description")}
                    ></Field>
                    <Field
                        type="input"
                        title={t("resources.new_productId")}
                        value={editResource["productId"]}
                        onChange={val => setEditResourceProductId(val)}
                        placeholder={t("resources.new_productId")}
                    ></Field>
                    <hr />
                    <h3 style={{ fontSize: "18px" }}>{t("resources.prop_title")}</h3>
                    {
                        editResource["props"] != undefined ? editResource["props"].map((item, key) =>
                            <div className="propContainer row " key={key} >
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resources.prop_name")}
                                        value={item["name"]}
                                        onChange={(val) => { handleEditPropName(val, key) }}
                                    ></Field>
                                </div>
                                <div className="col col-sm-5">
                                    <Field
                                        type="input"
                                        title={t("resources.prop_value")}
                                        value={item["value"]}
                                        onChange={(val) => { handleEditPropValue(val, key) }}
                                    ></Field>
                                </div>
                                <div className="col-sm-2">
                                    <Button onClick={() => deleteEditProp(key)}>{t("resources.prop_delete")}</Button>
                                </ div>
                            </div>
                        ) : null
                    }
                    <Button onClick={addEditProp}>{t("resources.prop_add")}</Button>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseEditModal}>
                        {t("resources.cancel")}
                    </Button>
                    <Button onClick={handleEditResource}>
                        {t("resources.save")}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Delete Modal */}
            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {t("resources.delete_resource")}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t("resources.delete_info")}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseDeleteModal}>
                        {t("resources.cancel")}
                    </Button>
                    <Button onClick={handleDeleteResource}>
                        {t("resources.delete_resource")}
                    </Button>
                </Modal.Footer>
            </Modal>

            <MaintenanceResourceModal
                showModal={showMaintenanceModal}
                closeModal={handleCloseMaintenanceModal}
                resourceID={currentResourceId}
                multiResources={multiResources}
                allResources={resources}
                showToggle={showToggle}
            />

            <EditMaintenance
                showEditMaintenance={showEditMaintenance}
                setShowEditMaintenance={setShowEditMaintenance}
                resourceID={currentResourceId}
                maintenanceKey={editMaintenanceKey}
                runOnEdit={fetchData}
            />
        </>
    )
}
export default Resources;